import { render, staticRenderFns } from "./userCoupon.vue?vue&type=template&id=56bc1f56&scoped=true&"
import script from "./userCoupon.vue?vue&type=script&lang=js&"
export * from "./userCoupon.vue?vue&type=script&lang=js&"
import style0 from "./userCoupon.vue?vue&type=style&index=0&id=56bc1f56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56bc1f56",
  null
  
)

component.options.__file = "userCoupon.vue"
export default component.exports